import axiosInstance from "../../../interceptor/axiosInstance";
import {CLASSROOMS} from "../../../routes/routeConstants/apiRoutes";
import {deserialize} from "serializr";
import Notification from "../../../shared/components/Notification";
import {NotificationTypes} from "../../../enums/notificationTypes";
import {PaginationModel} from "../../../models/PaginationModel/pagination.model";
import {ClassroomModel} from "../../../models/CourseModels/ClassroomModel/classroom.model";

export default class ClassroomService {
    static getClassroomsList(
        queryParams:string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(CLASSROOMS+queryParams)
            .then(response => {
                const classrooms = deserialize(ClassroomModel,response.data['class_rooms']);
                const pageMeta = deserialize(PaginationModel,response.data['meta']);
                onSuccess(classrooms,pageMeta);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to fetch the classes list",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static createClassroom(
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(CLASSROOMS,data)
            .then(response => {
                const classroom = deserialize(ClassroomModel,response.data['class_room']);
                onSuccess(classroom);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to create the class",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateClassroom(
        id: number,
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(CLASSROOMS+`/${id}`,data)
            .then(response => {
                const classroom = deserialize(ClassroomModel,response.data['class_room']);
                onSuccess(classroom);
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to update the class",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static deleteClassroom(
        id: number,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .delete(CLASSROOMS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({ message: "Failed", description: "Unable to delete the class",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }
}
